import { HttpMethod } from '../../constants';
export const enterprisesInvitationLinkEndpoints = {
  [HttpMethod.Get]: {
    EnterprisesInvitationLinks: {
      path: '/enterprises-invitation-links',
      route(): string {
        return this.path;
      }
    },
    EnterprisesInvitationLinkByToken: {
      path: '/enterprises-invitation-links/invitation-token/:enterpriseInvitationLinkToken',
      route(enterpriseInvitationLinkToken: string): string {
        return this.path.replace(':enterpriseInvitationLinkToken', enterpriseInvitationLinkToken);
      }
    }
  },
  [HttpMethod.Put]: {
    OneOrMany: {
      path: '/enterprises-invitation-links',
      route(): string {
        return this.path;
      }
    }
  },
  [HttpMethod.Delete]: {
    Many: {
      path: '/enterprises-invitation-links',
      route(): string {
        return this.path;
      }
    }
  }
};
export default enterprisesInvitationLinkEndpoints;